// page-all-designs

function collapse(wrapper) {
  wrapper.style.overflow = "hidden";
  wrapper.style.paddingBottom = "0px"; // hide bottom padding
  wrapper.style.maxHeight = "0px";
}

function expand(wrapper) {
  wrapper.style.overflow = "hidden";
  wrapper.style.paddingBottom = "2rem"; // restore padding before reading scrollHeight
  const height = wrapper.scrollHeight;
  wrapper.style.maxHeight = height + "px";
}

function setIconRotation(toggle, open, noAnimation = false) {
  const icon = toggle.querySelector(".icon-filter-two");
  if (!icon) return;
  icon.style.transition = noAnimation ? "none" : "transform 0.3s ease";
  icon.style.transform = open ? "rotate(180deg)" : "rotate(0deg)";
}

function toggleAccordion(wrapper, toggle) {
  const isOpen = wrapper.style.maxHeight && wrapper.style.maxHeight !== "0px";
  if (isOpen) {
    collapse(wrapper);
    toggle.setAttribute("aria-expanded", "false");
    setIconRotation(toggle, false);
  } else {
    expand(wrapper);
    toggle.setAttribute("aria-expanded", "true");
    setIconRotation(toggle, true);
  }
}

function initAccordions() {
  const toggles = document.querySelectorAll(
    ".collection-grid-accordion-toggle"
  );
  toggles.forEach((toggle) => {
    const grid = toggle.closest(".collection-grid");
    if (!grid) return;
    const wrapper = grid.querySelector(".collection-grid__wrapper--accordion");
    if (!wrapper) return;

    grid.classList.remove("opacity-hidden");

    // accessibility: make div behave like button
    toggle.setAttribute("role", "button");
    toggle.setAttribute("tabindex", "0");

    wrapper.style.transition = "max-height 0.4s ease";

    const shouldStartExpanded = toggle.getAttribute("aria-expanded") === "true";
    if (shouldStartExpanded) {
      expand(wrapper);
      setIconRotation(toggle, true, true);
    } else {
      collapse(wrapper);
      toggle.setAttribute("aria-expanded", "false");
      setIconRotation(toggle, false);
    }

    const handler = () => toggleAccordion(wrapper, toggle);
    toggle.addEventListener("click", handler);
    toggle.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handler();
      }
    });
  });
}

function updateCollectionCardFilters(garmentName, firstLoad = false) {
  const filterString = `?filter.p.tag=${garmentName.toLowerCase()}`;

  // get garments and departments data from JSON
  const garmentsJson = JSON.parse(
    document.getElementById("garments-data").textContent
  );
  const deptsData = garmentsJson.departments;
  const garmentData = garmentsJson.garments?.find(
    (g) => g.name === garmentName
  );
  if (!deptsData || !garmentData) return;

  // update collection card grids
  const deptGrids = document.querySelectorAll(".dept-grid");
  deptGrids.forEach((deptGrid) => {
    const deptHandle = deptGrid.getAttribute("data-dept-handle");
    const collectionList = deptGrid.querySelector("ul.collection-grid__list");
    const collectionItems = collectionList.querySelectorAll(
      ".collection-grid__li"
    );

    const deptHeader = deptGrid.querySelector(".collection-grid__dept-header");
    const garmentNameSpan = deptHeader.querySelector(
      ".dept-header__garment-name"
    );
    if (garmentNameSpan) garmentNameSpan.textContent = garmentName + "s";

    let hasAtLeastOneVisible = false;
    collectionItems.forEach((item) => {
      const collectionHandle = item.getAttribute("data-collection-handle");
      const collection = deptsData[deptHandle].find(
        (c) => c.handle === collectionHandle
      );
      const missingGarments = collection?.missing_garments;
      const missingGarment = missingGarments?.find(
        (missingGarment) => missingGarment === garmentName
      );

      if (missingGarment) {
        item.style.display = "none";
      } else {
        hasAtLeastOneVisible = true;
        item.style.display = "block";
      }

      const link = item.querySelector(
        ".collection-grid__link, .full-unstyled-link"
      );
      const currentHref = link.getAttribute("href");
      if (!currentHref) return;
      const baseUrl = currentHref.split("?")[0];
      link.setAttribute("href", baseUrl + filterString);
      const filterStringElement = item.querySelector(
        ".collection-grid__filter-string"
      );
      if (filterStringElement) filterStringElement.textContent = filterString;
    });

    if (hasAtLeastOneVisible) {
      deptGrid.classList.remove("hidden");
    } else {
      deptGrid.classList.add("hidden");
    }
  });

  // update accordion heights
  const toggles = document.querySelectorAll(
    ".collection-grid-accordion-toggle"
  );
  toggles.forEach((toggle) => {
    if (toggle.getAttribute("aria-expanded") === "true") {
      const grid = toggle.closest(".collection-grid");
      const wrapper = grid?.querySelector(
        ".collection-grid__wrapper--accordion"
      );
      if (wrapper) {
        const height = wrapper.scrollHeight;
        wrapper.style.maxHeight = height + "px";
      }
    }
  });

  // update header
  const pageHeader = document.querySelector(".all-designs-page--header");
  if (pageHeader) {
    const title = pageHeader.querySelector(".section-header__title");
    const subtitle = pageHeader.querySelector(".subtitle");
    if (title || subtitle) {
      if (subtitle) subtitle.textContent = garmentData.subheading;
      if (title) title.textContent = garmentData.name + "s";
    }
  }

  // update checked selector border
  const garmentTypeSelectorOptions = document.querySelectorAll(
    ".garment-type-selector__option"
  );
  garmentTypeSelectorOptions.forEach((option) => {
    const input = option.querySelector("input");
    if (!input) return;

    if (input.checked) {
      option.querySelector(".garment-type-selector__tile").style.borderColor =
        "var(--nc-green)";
    } else {
      option.querySelector(".garment-type-selector__tile").style.borderColor =
        "rgb(var(--color-border))";
    }
  });

  // update URL
  if (!firstLoad) {
    window.history.replaceState(
      {},
      "",
      `/pages/collections-${garmentName.toLowerCase().replace(/ /g, "-")}s`
    );
  }
}

function initGarmentTypeSelector() {
  const garmentTypeSelector = document.querySelector(
    ".all-designs-page.garment-type-selector"
  );
  if (!garmentTypeSelector) return;

  garmentTypeSelector.classList.remove("opacity-hidden");

  // function updateArrows() {
  //   const wrapper = garmentTypeSelector.querySelector(
  //     ".garment-type-selector__wrapper"
  //   );
  //   const containerWidth = garmentTypeSelector.clientWidth;
  //   const contentWidth = wrapper.scrollWidth;
  //   const showArrows = contentWidth > containerWidth;
  //   garmentTypeSelector
  //     .querySelectorAll(".swiper-arrow-button")
  //     .forEach((button) => button.classList.toggle("hidden", !showArrows));
  // }

  const swiper = new Swiper(".garment-type-selector__wrapper", {
    slidesPerView: 3.25,
    spaceBetween: 8,
    grabCursor: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".gts-swiper-arrow-buttons .swiper-button-next",
      prevEl: ".gts-swiper-arrow-buttons .swiper-button-prev",
    },
    breakpoints: {
      750: {
        spaceBetween: 16,
        slidesPerView: "auto",
      },
    },
    // on: {
    //   init: () => updateArrows(),
    //   resize: () => updateArrows(),
    // },
  });

  const garmentTypeSelectorOptions = garmentTypeSelector.querySelectorAll(
    ".garment-type-selector__option"
  );
  garmentTypeSelectorOptions.forEach((option) => {
    const input = option.querySelector("input");
    if (!input) return;
    input.addEventListener("change", () => {
      updateCollectionCardFilters(input.value);
    });
    if (input.checked) updateCollectionCardFilters(input.value, true);
  });
}

document.addEventListener("DOMContentLoaded", async () => {
  initAccordions();
  initGarmentTypeSelector();
  // const unfoundStrings = await unfoundSearchStrings(
  //   "night-channels",
  //   "06c7bcce733d19e0bd92c98a4dcd2816",
  //   "noise-music",
  //   [
  //     "classic-tee",
  //     "comfort-colors",
  //     "slimfit-tee",
  //     "muscle-tee",
  //     "baby-tee",
  //     "tank",
  //     "hoodie",
  //   ]
  // );
  // console.log(unfoundStrings);
});

async function unfoundSearchStrings(shop, token, collectionHandle, probes) {
  const endpoint = `https://${shop}.myshopify.com/api/2025-07/graphql.json`;

  const query = /* GraphQL */ `
    query ($handle: String!, $cursor: String) {
      collectionByHandle(handle: $handle) {
        products(first: 250, after: $cursor) {
          edges {
            node {
              handle
            }
            cursor
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    }
  `;

  // Gather all product handles via pagination
  const handles = [];
  let cursor = null;
  do {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token,
      },
      body: JSON.stringify({
        query,
        variables: { handle: collectionHandle, cursor },
      }),
    });
    const json = await res.json();
    const products = json.data.collectionByHandle?.products;
    if (!products) break;

    products.edges.forEach((edge) => handles.push(edge.node.handle));
    cursor = products.pageInfo.hasNextPage
      ? products.edges[products.edges.length - 1].cursor
      : null;
  } while (cursor);

  // Case-insensitive search
  const lowerHandles = handles.map((h) => h.toLowerCase());
  return probes.filter(
    (probe) =>
      !lowerHandles.some((handle) => handle.includes(probe.toLowerCase()))
  );
}
